module.exports = __webpack_public_path__ + "img/search-icon.682a145b.svg";